import React, { useContext, useMemo, useState } from 'react'
import { useHistory } from '../../../../../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { AuthContext } from '../../../../../../context/auth.context'
import { useApiFormNodeTemplate, useApiListNodeTemplateCategory } from '../../../../../../api-new/state/content'
import { useLoad } from '../../../../../../shared/hooks/load'
import { TemplateMenu } from '../../common/menu/node-actions'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { IconCopy } from '../../../../../../shared/icon/icon'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { NodeCaffeine } from '../../common/shared/node-caffeine'
import { LoginSysAdmin } from '../../../../../../role/components/login-sys-admin'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleHiddenNumber } from '../../../../../../shared/form-simple/form-hidden-number'
import { FormSimpleOrgaizationSelect } from '../../../../../../shared/form-simple/form-organization-select-filter'
import { FormSimpleText } from '../../../../../../shared/form-simple/form-text'
import { FormSimpleSubmitEdit } from '../../../../../../shared/form-simple/form-submit'
import { FormSimpleCategoryOrganizationSelectFilter } from '../../../../../../shared/form-simple/form-category-organization-select-filter'
import { useTransferContext } from '../../../../../../shared/transfer/transfer-provider'
import { useTransferComplete, useTransferNodeCopyAllowGoto } from '../../../../../../shared/transfer/hooks/transfer-data'
import { TransferCopyNodeStatus } from '../../../../../../shared/transfer/components/transfer-copy-node-status'
import { useDataContext } from '../data-context'
import { pathNodeTemplate } from '../../common/shared/path-node-template'

export const NodeTemplateCopy = ({ nodeID, parentURL }) => {
  const authContext = useContext(AuthContext)

  const apiFormNodeTemplate = useApiFormNodeTemplate()

  const title = useMemo(() => `copy ${apiFormNodeTemplate.form.name}`, [apiFormNodeTemplate.form.name])

  const [organizationID, updateOrganizationID] = useState(null)

  useLoad(
    () => {
      authContext.state.organizationID && updateOrganizationID(authContext.state.organizationID)
    },
    [authContext.state.organizationID]
  )

  const handleMatch = () => apiFormNodeTemplate.get(nodeID)

  const HeaderMenu = () => <TemplateMenu place="header" url={parentURL} node={apiFormNodeTemplate.form} />

  const handleOrgChange = value => {
    if (value) {
      updateOrganizationID(value.id)
    } else {
      updateOrganizationID(null)
    }
  }

  ///////////////

  const history = useHistory()

  const dataContext = useDataContext()
  const transferContext = useTransferContext()

  const transferID = useMemo(() => `template-copy-${nodeID}`, [nodeID])

  const transfer = useMemo(() => transferContext.items[transferID] || null, [transferContext.items, transferID])

  const active = useMemo(() => !!transfer, [transfer])

  const allowGoto = useTransferNodeCopyAllowGoto(transfer, authContext.state.organizationID)

  useTransferComplete(transfer, () => {
    dataContext.reload()
  })

  const handleSubmit = async data => {
    if (data.destParentID === -1) {
      data.destParentID = null
    }

    const transfer = transferContext.nodeCopyTemplate(transferID, data.destName, history.location.pathname)
    transfer.start(data)
  }

  const handleGoTo = async nodeID => {
    let nodes = [...dataContext.categories, ...dataContext.templates]
    let path = pathNodeTemplate(nodes, nodeID)
    history.push(path)
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconCopy} text="Copy template" onMatch={handleMatch}>
        <CardFullHeightScrollY title={title} HeaderMenu={HeaderMenu}>
          <NodeCaffeine node={apiFormNodeTemplate.form}>
            <FormSimple disabled={active} onSubmit={handleSubmit}>
              <FormSimpleHiddenNumber name="srcNodeID" value={nodeID} required />

              <LoginSysAdmin>
                <FormSimpleOrgaizationSelect name="organizationID" defaultValue={organizationID} required onChange={handleOrgChange} />
              </LoginSysAdmin>

              {organizationID &&
                <FormSimpleCategoryOrganizationSelectFilter
                  name="destParentID"
                  label="category"
                  rootName="TEMPLATE"
                  organizationID={organizationID}
                  useApiListCategory={useApiListNodeTemplateCategory}
                  required
                />}

              <FormSimpleText name="destName" label="name" defaultValue={apiFormNodeTemplate.form.name} required />
              <FormSimpleSubmitEdit text="copy course" backURL={parentURL} />
            </FormSimple>

            <TransferCopyNodeStatus transfer={transfer} allowGoto={allowGoto} gotoText="view new template" onGoTo={handleGoTo} />
          </NodeCaffeine>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
